import { Box, Divider, Typography } from "@mui/material";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../../../components/common/BriaButton/BriaButton";
import { useAppStore } from "../../../../../../hooks/useStores";
import Icons from "../../../../../components/Icons";
import { PanelType } from "../../../../../constants/app-options.ts";
import { DesignEditorContext } from "../../../../../contexts/DesignEditor.tsx";
import { getFillColor } from "../../../../../core/utils/gradient_color_utils";
import { useActiveObject } from "../../../../../hooks/useActiveObject";
import useAppContext from "../../../../../hooks/useAppContext";
import { useEditor } from "../../../../../hooks/useEditor";
import useSetIsSidebarOpen from "../../../../../hooks/useSetIsSidebarOpen.tsx";
import EditAllAdsSwitch from "../../Panels/panelItems/Common/EditAllAdsSwitch/EditAllAdsSwitch";
import styles from "./Canvas.module.scss";

const Canvas = () => {
	const editor = useEditor();
	const activeObject = useActiveObject() as any;
	const { setActivePanel } = useAppContext();
	const setIsSidebarOpen = useSetIsSidebarOpen();
	const { campaignStore, uiStore } = useAppStore();
	const { isPopupView } = useContext(DesignEditorContext);
	const [_state, setState] = React.useState({ fill: "#000000" });
	const { t } = useTranslation("translation", { keyPrefix: "editor.controllers" });

	useEffect(() => {
		if (editor) {
			setState({ fill: editor.canvas.backgroundColor as string });
			// Initialize canvasColorPicker with the correct fill color
			if (editor.frame?.background?.fill) {
				const fillColor = getFillColor(editor.frame.background.fill);
				campaignStore.canvasColorPicker = fillColor;
			}
		}
	}, [editor]);

	useEffect(() => {
		const watcher = async () => {
			if (editor?.frame?.background?.fill) {
				// Use getFillColor to handle both solid colors and gradients
				const fillColor = getFillColor(editor.frame.background.fill);
				campaignStore.canvasColorPicker = fillColor;
			} else {
				campaignStore.canvasColorPicker = "#fff";
			}
			setState({ fill: editor?.canvas.backgroundColor as string });
		};

		if (editor) {
			editor.on("canvas:updated", watcher);
		}

		return () => {
			if (editor) {
				editor.off("canvas:updated", watcher);
			}
		};
	}, [editor, activeObject]);

	return (
		<Box
			className={clsx({
				[styles.container]: true,
				[styles.hide]: isPopupView,
			})}
		>
			<Box
				className={clsx({
					[styles.canvasControlsContainer]: true,
					[styles.noMarginRight]: uiStore.showGuideSection,
				})}
			>
				<Box className={styles.canvasControlsWrapper}>
					<BriaButton
						buttonType="textMedium"
						onClick={() => {
							setIsSidebarOpen(true);
							setActivePanel(PanelType.RESIZE);
						}}
						className={styles.ControlButtonWrapper}
					>
						<Icons.Resize size={24} />
						<Typography className={styles.Label}>{t("canvasControllers.Resize")}</Typography>
					</BriaButton>
					<Divider className={styles.divider} orientation={"vertical"} />
					<Box
						style={{
							backgroundColor: campaignStore.canvasColorPicker,
							background: campaignStore.canvasColorPicker,
						}}
						onClick={() => {
							setIsSidebarOpen(true);
							setActivePanel(PanelType.CANVASCOLOR);
						}}
						className={styles.colorBox}
					></Box>
					<Typography className={styles.Label}>{t("fill")}</Typography>
				</Box>

				<Box>
					<EditAllAdsSwitch />
				</Box>
			</Box>
		</Box>
	);
};

const ObservedComponent = observer(Canvas);
export default ObservedComponent;
